// import the library
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
// import your icons
import {
  faCode,
  faHome,
  faEnvelopeSquare,
  faHighlighter,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faCode,
  faHighlighter,
  faEye,
  faEyeSlash,
  faEnvelopeSquare,
  faHome,
  faSpinner

  // more icons go here
);
